import React from 'react';

const HUD = () => {
  return (
    <div className="hud logo">
      <a href="https://timelit.ai" target="_blank" rel="noopener noreferrer">
        Timelit
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M7 17L17 7M17 7H7M17 7V17" />
        </svg>
      </a>
      NVM
    </div>
  );
};

export default HUD;

